import Grid from '@material-ui/core/Grid';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { IProject } from '../../modules/Projects/models';
import { ROUTES } from '../../router/consts';
import { makePath } from '../../utils';
import { ProjectPreview } from '../ProjectPreview';

interface IProps {
    projects: IProject[];
}

export const ProjectList: React.FC<IProps> = ({ projects }) => {
    return projects ? (
        <div className="project-list">
            <Grid container spacing={2}>
                {
                    projects.map((project, index) => (
                        <Grid key={index} item xs={12} md={6}>
                            <Link to={makePath<{ slug: string }>(ROUTES.PROJECT, { slug: project.slug })}>
                                <ProjectPreview project={project} index={index} />
                            </Link>
                        </Grid>
                    ))
                }
            </Grid>
        </div>
    ) : null;
};
